export const getProblemApiErrorMessage = (e: any, t: any) => {
  let message = t('error.unknown.body');
  if (e?.key) {
    message = t(e.key);
  } else if (e?.message) {
    message = t('general.text.no.translation', { value: e.message });
  }

  return message;
};
